import { createAction, props } from '@ngrx/store';

import {
  type CropData,
  type FileItem,
  type FileItemFromComputer,
  type FileResult,
  type NotificationData,
  type ResourceResult,
} from '../../../domain/public-api';

export const resetFilesState = createAction('[Files] Reset state');

export const prepareFilesFromComputer = createAction(
  '[Files] Prepare files from computer',
  props<{ files: File[] }>(),
);

export const addFilesFromComputer = createAction(
  '[Files] Add files from computer',
  props<{ fileItems: FileItemFromComputer[] }>(),
);

export const removeAllFiles = createAction('[Files] Remove all files');

export const removeFile = createAction('[Files] Remove file', props<{ fileId: number }>());

export const startImageEdit = createAction('[Files] Start image edit', props<{ fileId: number }>());

export const saveImageEdit = createAction(
  '[Files] Save image edit',
  props<{ cropData: CropData }>(),
);

export const undoImageEdit = createAction('[Files] Undo image edit', props<{ fileId: number }>());

export const cancelImageEdit = createAction('[Files] Cancel image edit');

export const startUploadTry = createAction(
  '[Files] Upload: Start upload: try',
  props<{ fileItems: FileItem[] }>(),
);

export const startUpload = createAction(
  '[Files] Upload: Start upload',
  props<{ fileItems: FileItem[] }>(),
);

export const uploadFile = createAction(
  '[Files] Upload: Upload file',
  props<{ fileId: number; data: File | Blob; resourceId: string; url: string }>(),
);

export const setUploadFileProgress = createAction(
  '[Files] Upload: Set file progress',
  props<{ resourceId: string; progress: number }>(),
);

export const waitForUpload = createAction(
  '[Files] Upload: Wait for upload',
  props<{ fileId: number; resourceId: string }>(),
);

export const waitForUploadError = createAction(
  '[Files] Upload: Wait for upload - error',
  props<{ resourceId: string }>(),
);

export const finishUpload = createAction(
  '[Files] Upload: Finish upload',
  props<{ fileId: number; resourceId: string }>(),
);

export const errorUploads = createAction(
  '[Files] Upload: Uploads error',
  props<{ fileIds: number[] }>(),
);

export const uploadFinished = createAction(
  '[Files] Upload: Upload finished',
  props<{ resourceId: string }>(),
);

export const startEncoding = createAction(
  '[Files] Upload: Start encoding',
  props<{ resourceId: string }>(),
);

export const setEncodingProgress = createAction(
  '[Files] Upload: Set encoding progress',
  props<{ resourceId: string; progress: number }>(),
);

export const errorEncoding = createAction(
  '[Files] Upload: Error encoding',
  props<{ resourceId: string }>(),
);

export const finishEncoding = createAction(
  '[Files] Upload: Finish encoding',
  props<{ resourceId: string; resource: ResourceResult }>(),
);

export const confirmUpload = createAction('[Files] Upload: Confirm upload');

export const revokeUploadConfirmation = createAction('[Files] Upload: Revoke upload confirmation');

export const fileRetry = createAction('[Files] Upload: File retry', props<{ fileId: number }>());

export const confirmFiles = createAction(
  '[Files] Confirm files',
  props<{ fileItems: FileItem[] }>(),
);

export const returnFiles = createAction(
  '[Files] Return files',
  props<{ fileResults: FileResult[] }>(),
);

export const triggerNotifications = createAction(
  '[Files] Trigger notifications',
  props<{ notifications: NotificationData[] }>(),
);
